import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
export const resetState = createAction("RESET_STATE");

export const isbookingValid = createAsyncThunk(
  "bookingValidation",
  async (values) => {
    const { booking_id, last_name } = values;
    var requestOptions = {
      method: "POST",
      // redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payload: {
          booking_id: booking_id,
          last_name: last_name,
        },
        action_type: "GETUSERDETAILS",
      }),
    };

    return await fetch(
      `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`,
      requestOptions
    )
      .then((response) => {
        return response.json();
      })
      .catch((error) => console.log("error", error));
  }
);

export const isOTPValid = createAsyncThunk(
  "bookingValidation",
  async (values) => {
    const { booking_id, guest_id, otp } = values;
    var requestOptions = {
      method: "POST",
      // redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payload: {
          booking_id: booking_id,
          otp: otp,
          guest_id: guest_id,
        },
        action_type: "VERIFYOTP",
      }),
    };

    return await fetch(
      `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`,
      requestOptions
    )
      .then((response) => {
        return response.json();
      })
      .catch((error) => console.log("error", error));
  }
);

const bookingValidationSlice = createSlice({
  name: "bookingValidation",
  initialState: {
    isLoading: false,
    data: null,
    loggedInStatus: null,
  },
  extraReducers: (builder) => {
    builder.addCase(
      isbookingValid.pending || isOTPValid.pending,
      (state, action) => {
        state.isLoading = true;
        state.isError = false;
      }
    );
    builder.addCase(
      isbookingValid.fulfilled || isOTPValid.fulfilled,
      (state, action) => {
        state.data = action.payload;
        if (!state.loggedInStatus && action.payload.status === "success") {
          toast.success("Login successful");
        }
        state.loggedInStatus =
          action.payload.status === "success" ? true : false;
        if (!state.loggedInStatus) {
          toast.error("Login failed! Please try again.");
        }
        state.isLoading = false;
      }
    );
    builder.addCase(
      isbookingValid.rejected || isOTPValid.rejected,
      (state, action) => {
        state.isError = true;
      }
    );
    builder.addCase(resetState, (state, action) => {
      state.loggedInStatus = null;
      state.data = null;
    });
  },
});

export default bookingValidationSlice.reducer;
